import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_QUERY = graphql(/* GraphQL */ `
	query discountLongTermForLongTermStay($hotelID: String!, $discountId: String!) {
		discountLongTerm(hotelID: $hotelID, discountID: $discountId) {
			name
			hotelID
			discountID
			discountCode
			inSale
			description
			isUncancelable
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			resourceLowestPrice {
				currencyType
				amount
			}
			discountPriceTotalLimit {
				amount
				currencyType
			}
			longTermStayDiscountObject {
				includeSmallestNights
				discountType
				ratio
				staticTargetType
				static {
					currencyType
					amount
				}
			}
			roomConditionType
		}
	}
`);
